module.exports = __webpack_public_path__ + "static/media/helpnew.706b452c.svg";